import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";

const ViewContact = (props) => {
    document.title = "DirtMap - Contact Details";
    const history = useHistory();
    // const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [contact, setContect] = useState([]);
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    //console.log(id);
    useEffect(() => {
        showLoader();
        let isMounted = true;
        axios.get(`api/contact/detail/${props.match.params.id}`).then(res => {
            if (isMounted) {
                if (res.data.result) {
                    hideLoader();
                    setContect(res.data.result);
                    setLoading(false);
                } else if (res.data.status === 'false') {
                    hideLoader();
                    history.push('/');
                    swal("warning", res.data.message, "error");
                }
            }

        });
        return () => {
            isMounted = false;
            hideLoader();
        };
    }, [props.match.params.id, history]);

    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;
    } else {

    }
    return (
        <main className="main">
            <div className="container-fluid">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <h4 className="card-title mb-0"> Contact Details</h4>
                            </div>

                        </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered" width="100%">

                                <tbody>
                                    <tr>
                                        <th >Name:</th>
                                        <td>{contact.name}</td>
                                    </tr>
                                    <tr>
                                        <th >Email:</th>
                                        <td>{contact.email}</td>
                                    </tr>
                                    <tr>
                                        <th >Phone:</th>
                                        <td>{contact.phone}</td>
                                    </tr>
                                    <tr>
                                        <th >Message:</th>
                                        <td>{contact.message}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {loader}
        </main>
    )
}

export default ViewContact;